<template>
    <!-- BEGIN FOOTER -->
    <div class="footer-wrapper">
        <div class="footer-section f-section-1">
            <p class="">Copyright © 2025 <a target="_blank" href="https://eihc.trustdigital.space">Jor25 Health Care</a>, All rights reserved.</p>
        </div>
  
    </div>
    <!-- END FOOTER -->
</template>
